import fetch from './fetch';
import utils from './../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'orgName', label: '部门',width: 120},
    {key:'employeeCode', label: '教师工号',width: 90},
    {key:'employeeName', label: '教师姓名',width: 60},
    {key:'teacherAttributes', label: '教师属性',width: 50},
    {key:'orgNum', label: '开课部门人数',width: 40},
    {key:'evalName', label: '评价方',width: 60},
    {key:'evalNum', label: '已评次数',width: 40},
    {key:'bgTermName', label: '开始学期',width: 90},
    {key:'endTermName', label: '结束学期',width: 90}
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    return fetch.post('/opening/teacher/summary/list', keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    }).then(response => (Object.assign({
        meta: response.meta,
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const exportScore = (keywords) => {
    return fetch.download('/opening/teacher/summary/export', keywords, "开课教师测评汇总.xls")
}

const getTargetName = (targetId) => {
    return fetch.get('/opening/teacher/summary/get/'+ targetId)
    .then(response => {
        return response.payload.data.evalName;
    })
}

/**
 * 数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
const exportList = (keywords) => {
    return fetch.download('/opening/teacher/summary/exportHonor', keywords, "开课教师汇总导出.xls")
}
export default {
    querySearch,
    headers,
    onSelect,
    exportScore,
    setRefresh,
    getTargetName,
    exportList

}
